import React from 'react'
import style from './recipe.module.css';

const Recipe = ({ mainData, key, title, calories, image, ingredients}) => {
  return(
    <div key={calories} className={style.recipe}>
      <h1>Title: {title}</h1>
      <ol>
        {ingredients.map(ingrediant => (
          <li>{ingrediant.text}</li>
        ))}
      </ol>
      <p>Calories: {calories}</p>
      <img className={style.image} src={image} alt=""/>
    </div>
  );
}

export default Recipe;